import moment from 'moment-timezone';

export const formatDateMonthYear = (date) => {
    return moment.tz(date, 'America/Chicago').format('M/YYYY');
};

export const formatDateYearMonth = (date) => {
    return moment.tz(date, 'America/Chicago').format('YYYY/MM');
};

export const formatMonth = (date) => {
    try {
        const month = Number(moment.tz(date, 'America/Chicago').format('M')) - 1
        return moment.months()[month]
    } catch (error) {
        console.error(error)
    }

    return "Error"
}